import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
let Awards = class Awards extends Mixins(ViewportSizeMixin) {
    get awards() {
        return [
            {
                img: 'hackatax',
                label: 'Hack-A-Tax Grand Winner',
            },
            {
                img: 'inqbation',
                label: 'INQBATION: Leveling Up B2B Startups',
            },
            {
                img: 'microsoft',
                label: 'One of the Microsoft Emerge X Winners',
            },
        ].map(({ img, label }) => ({
            img: `${S3_ASSETS_BUCKET_URL}/award-${img}.png`,
            label,
        }));
    }
    get imgHeight() {
        return this.mdAndUp ? 392 : 292;
    }
};
Awards = __decorate([
    Component({
        components: {
            Hooper,
            Slide,
            HooperPagination,
        },
    })
], Awards);
export default Awards;
